module.exports = __webpack_public_path__ + "img/google.d40c12a7.png";